import I18n from 'I18n';
// @ts-expect-error untyped dependency
import localeComparator from 'I18n/utils/localeComparator';
import unescapedText from 'I18n/utils/unescapedText';
import { BY_CATEGORY as FEATURES_BY_CATEGORY } from 'ecosystem-marketplace-core/constants/groupTags/categoryFeatures';
import { getCategoryFeatureI18nKey } from 'marketplace-ui-apps-core/common/utils/i18n';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
import { jsx as _jsx } from "react/jsx-runtime";
function getCategoryFeatureOptions(category) {
  if (!(category in FEATURES_BY_CATEGORY)) {
    return [];
  }
  const categoryFeatures = Object.values(FEATURES_BY_CATEGORY[category]);
  return categoryFeatures.map(_value => ({
    text: I18n.text(getCategoryFeatureI18nKey(category, _value)),
    value: _value
  })).sort((a, b) => localeComparator(a.text, b.text));
}
export default function CategoryFeaturesFilter({
  activeCategory,
  onChange,
  scrollable = true,
  value
}) {
  return /*#__PURE__*/_jsx(FilterToggleGroup, {
    ariaLabel: unescapedText('appMarketplace.storefront.filters.categoryFeatures.titleText'),
    multi: true,
    name: "category-features",
    onChange: onChange,
    options: getCategoryFeatureOptions(activeCategory),
    scrollable: scrollable,
    value: value
  }, `category-features-${activeCategory}`);
}